import _get from 'lodash/get'

import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import { FAILURE_REASONS } from './constants'
import type { GetFailureReason } from './types'

const getDentalFailureReason: GetFailureReason = ({
  formValues,
  stepTransformer = (step: string) => step,
  currentStep,
  productKey = 'dental_ottonova_75_plus_de',
}) => {
  // We need the product key here because in WBF we are selling the exact same product with different product keys
  const { getParamPath, getHelperPath } = generateGetFlowValueFunctions(productKey)

  switch (currentStep) {
    case stepTransformer('dental_insurance_type'): {
      const insuranceType = _get(formValues, getHelperPath('insurance_type'))
      return {
        reason: FAILURE_REASONS.NO_EXISTING_HEALTH_INSURANCE,
        extraData: { insuranceType },
      }
    }
    case stepTransformer('dental_missing_teeth'): {
      const missingTeeth = _get(formValues, getParamPath('not_replaced_missing_teeth_count'))
      return {
        reason: FAILURE_REASONS.TOO_MANY_MISSING_TEETH,
        extraData: { missingTeeth },
      }
    }
    case stepTransformer('dental_previous_insurance_notice'): {
      const existingInsurance = _get(
        formValues,
        getParamPath('has_other_dental_insurance_at_insurance_start')
      )
      return {
        reason: FAILURE_REASONS.EXISTING_INSURANCE,
        extraData: { existingInsurance },
      }
    }
    case stepTransformer('dental_removable_teeth'): {
      const removableTeeth = _get(formValues, getParamPath('removable_dental_prosthesis'))
      return {
        reason: FAILURE_REASONS.REMOVABLE_TEETH,
        extraData: { removableTeeth },
      }
    }

    case stepTransformer('treated_peridontal_disease_3_years'): {
      const treatedPeriodontalDisease = _get(
        formValues,
        getParamPath('treated_peridontal_disease_3_years')
      )
      return {
        reason: FAILURE_REASONS.HAS_PERIODONTAL_DISEASE,
        extraData: { treatedPeriodontalDisease },
      }
    }
    default: {
      break
    }
  }
}
export default getDentalFailureReason
